import React, { useEffect, useState } from "react";
import classNames from "classnames";
import {
  Edit,
  HouseOutlined,
  Language,
  LocationOnOutlined,
  MonitorHeartOutlined,
  MyLocation,
  NoteSharp,
  PeopleSharp,
  Person,
  GroupAdd,
  More,
} from "@mui/icons-material";
import moment from "moment/moment";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCreatePOCMutation,
  useDeletePOCMutation,
  useFetchPatientByIdMutation,
  useFetchPatientCareteamMutation,
  useFetchPatientPOCMembersMutation,
  useUpdatePatientNotesMutation,
  useUpdatePOCMutation,
  // useFetchPatientHouseholdMembersMutation,
} from "../../../features/patient/patientApiSlice";
import { useFetchReferralSourcesMutation } from "../../../features/organisation/organisationApiSlice";
import IconComponent from "../../../components/DataTable/Icon";
import POCDeleteModal from "./components/POCDeleteModal";
import POCModal from "./components/POCModal";
import Loading from "../../../components/Loading";
import Search from "../../../components/Search/SearchNew";
import { useCreateLogsMutation } from "../../../features/logs/logsApiSlice";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
  GENDER,
  programs,
} from "../../../constants/config.constants";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/auth/authSlice";
import { Icon } from "@virtuslab/tetrisly-icons";
import VisitHistory from "./components/VisitHistory";
import PatientUpdateModal from "./components/PatientUpdate";
import PatientZoneEditModal from "./components/PatientZoneEditModal";
import { Tooltip } from "@mui/material";
import InsuranceDetails from "./components/InsuranceDetails";
import LatLongDisplay from "./components/LatLatLongDisplay";

const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

const formatZipCode = (zip) => {
  if (!zip) return zip;
  
  // Remove any existing hyphens and non-digit characters
  const cleanedZip = zip.toString().replace(/[^\d]/g, '');
  
  // If already has hyphen in correct format, return as is
  if (zip.includes('-') && /^\d+-\d+$/.test(zip)) {
    return zip;
  }
  
  // Format based on length
  if (cleanedZip.length === 9) {
    // Format as 5-4 (standard US ZIP+4)
    return `${cleanedZip.slice(0, 5)}-${cleanedZip.slice(5)}`;
  } else if (cleanedZip.length === 8) {
    // Format as 4-4 (as per user's example)
    return `${cleanedZip.slice(0, 4)}-${cleanedZip.slice(4)}`;
  } else if (cleanedZip.length === 5) {
    // Standard 5-digit zip, return as is
    return cleanedZip;
  }
  
  // For any other length, return cleaned version
  return cleanedZip;
};

const PatientInfo = () => {
  // const [patients, setPatients] = React.useState([]);
  const [careteam, setCareteam] = React.useState([]);
  const [patient, setPatient] = React.useState(null);
  const [poc, setPOC] = React.useState([]);
  const [addPOCOpen, setAddPOCOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(null);
  const [del, setDel] = React.useState(null);
 

  const [pocFirstName, setPocFirstName] = React.useState("");
  const [pocLastName, setPocLastName] = React.useState("");
  const [pocStreet, setPocStreet] = React.useState("");
  const [pocCity, setPocCity] = React.useState("");
  const [pocState, setPocState] = React.useState("");
  const [pocZip, setPocZip] = React.useState("");
  const [pocPhone, setPocPhone] = React.useState("");
  const [pocSecondaryPhone, setPocSecondaryPhone] = React.useState("");
  const [pocEmail, setPocEmail] = React.useState("");
  const [pocCategory, setPocCategory] = React.useState("");
  const [pocType, setPocType] = React.useState("");

  const [searchFilter, setSearchFilter] = React.useState("");

  const [tab, setTab] = React.useState("care-team");
  const [isEditNote, setIsEditNote] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState("");
  const [note, setNote] = React.useState("");
  const [referralSource, setReferralSource] = React.useState([]);

  const [zoneEditModalOpen, setZoneEditModalOpen] = React.useState(false);

  // lat-long

  const [selectedAddress, setSelectedAddress] = useState('');
  const [selectedAddressType, setSelectedAddressType] = useState('PRIMARY');
  const [coordinates, setCoordinates] = useState({ lat: '', lng: '' });
  const [loading, setLoading] = useState(false);


  const { id } = useParams();

  const navigate = useNavigate();

  const handlePatientClick = (patient) => {
    navigate(`/data-management/patients/${patient.id}`);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleProviderClick = (provider) => {
    let url = `/data-management/providers/${provider.id}`;
    if (provider.provider_market_id) {
      url += `?market=${provider.provider_market_id}`;
    }
    navigate(url);
  };

  const handleTabChange = (newTab) => {
    if (newTab !== tab) {
      setTab(newTab);
    }
  };

  // const [getPatients] = useFetchPatientHouseholdMembersMutation();
  const [getPatientCareteam, { isLoading: careLoading }] =
    useFetchPatientCareteamMutation();
  const [getPatientPOC, { isLoading: pocLoading }] =
    useFetchPatientPOCMembersMutation();

  const [getPatientById, { isLoading: patientLoading }] =
    useFetchPatientByIdMutation();

  const [createPOC, { isLoading: createLoading }] = useCreatePOCMutation();
  const [updatePOC, { isLoading: updateLoading }] = useUpdatePOCMutation();
  const [deletePOC, { isLoading: deleteLoading }] = useDeletePOCMutation();
  const [updatePatientNotes, { isLoading: updateNoteLoading }] =
    useUpdatePatientNotesMutation();
  const [createLog] = useCreateLogsMutation();
  const [fetchReferralSources] = useFetchReferralSourcesMutation();

  const user = useSelector(selectUser);

  const isLoading =
    careLoading ||
    updateLoading ||
    createLoading ||
    deleteLoading ||
    patientLoading ||
    updateNoteLoading;

  // const fetchPatients = async () => {
  //   try {
  //     const { data } = await getPatients(patient.locationId).unwrap();

  //     setPatients(data);
  //   } catch (error) {
  //
  //     console.error(error.data.message);
  //   }
  // };

  const fetchPatient = async () => {
    try {
      const { data } = await getPatientById(id).unwrap();
      setNote(data.notes ?? "");
      setPatient(data);
    } catch (error) {
      console.error(error.data.message);
    }
  };

  const getReferralSources = async () => {
    try {
      const { data } = await fetchReferralSources({
        orgId: user.organisation.id,
      }).unwrap();

      setReferralSource(
        data?.filter((e) => e?.ref_type === "referralSource") || []
      );
    } catch (error) {
      console.error(error.data.message);
    }
  };

  const fetchCareteam = async () => {
    try {
      const { data } = await getPatientCareteam(id).unwrap();

      setCareteam(data);
    } catch (error) {
      console.error(error.data.message);
    }
  };

  const fetchPatientPOC = async () => {
    try {
      const { data } = await getPatientPOC(id).unwrap();

      setPOC(data);
    } catch (error) {
      console.error(error.data.message);
    }
  };

  const savePOC = async () => {
    const payload = {
      activity: `New point of contact (${pocFirstName} ${pocLastName}) added by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.POC_ADD,
      data: {
        patientId: id
      }
    };
    try {
      const { data } = await createPOC({
        patientId: id,
        firstname: pocFirstName,
        lastname: pocLastName,
        street: pocStreet,
        city: pocCity,
        state: pocState,
        zip: pocZip,
        phone: pocPhone,
        secondaryphone: pocSecondaryPhone,
        email: pocEmail,
        category: pocCategory,
        type: pocType,
      }).unwrap();

      const pocList = [data, ...poc];
      setPOC(pocList);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  const onUpdatePOC = async () => {
    const payload = {
      activity: `Point of contact (${pocFirstName} ${pocLastName}) updated by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.POC_UPDATE,
      data: {
        patientId: id
      }
    };
    try {
      const { data } = await updatePOC({
        id: edit,
        firstname: pocFirstName,
        lastname: pocLastName,
        street: pocStreet,
        city: pocCity,
        state: pocState,
        zip: pocZip,
        phone: pocPhone,
        secondaryphone: pocSecondaryPhone,
        email: pocEmail,
        category: pocCategory,
        type: pocType,
      }).unwrap();

      setPOC((prev) => {
        const update = [...prev];
        const index = update.findIndex((x) => x.id === edit);
        update[index] = data;
        return [...update];
      });
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  const onDeletePOC = async () => {
    const payload = {
      activity: `Point of contact (${pocFirstName}) deleted by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.POC_ADD,
      data: {
        patientId: id
      }
    };
    try {
      const { data } = await deletePOC({
        id: del,
      }).unwrap();

      setPOC((prev) => {
        const update = [...prev];
        const index = update.findIndex((x) => x.id === del);
        update[index] = {
          ...data,
          email: update[index]?.email,
          phone: update[index]?.phone,
        };
        return [...update];
      });
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  const updateNote = async () => {
    const payload = {
      activity: `Note updated for Patient (${patient?.name}) by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.PATIENT_NOTE_UPDATE,
      data: {
        patientId: id
      }
    };
    try {
      const { data } = await updatePatientNotes({
        patientId: id,
        notes: note,
      }).unwrap();

      setPatient({
        ...patient,
        notes: data.notes,
      });
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  const clearInput = () => {
    setPocFirstName("");
    setPocLastName("");
    setPocStreet("");
    setPocCity("");
    setPocState("");
    setPocZip("");
    setPocPhone("");
    setPocSecondaryPhone("");
    setPocEmail("");
    setPocCategory("");
    setPocType("");
    setEdit(null);
    setDel(null);
  };

  React.useEffect(() => {
    if (id) {
      Promise.allSettled([
        fetchPatient(),
        fetchCareteam(),
        fetchPatientPOC(),
        getReferralSources(),
      ]).then((results) => {
        results.forEach((result) => {
          if (result.status === "rejected") {
            console.error("Error fetching data:", result.reason);
          }
        });
      });
    }
  }, [id]);

  // React.useEffect(() => {
  //   if (patient && patient.noOfMembers > 0) {
  //     fetchPatients();
  //   }
  // }, [patient]);

  const group_name = patient?.isMember ? "members_dm" : "patients_dm";

  const onEdit = (contact) => {
    const [firstname, lastname] = contact.name.split(" ");
    const [street, city, state, zip] = contact.address.split(", ");
    setPocFirstName(firstname);
    setPocLastName(lastname);
    setPocStreet(street);
    setPocCity(city);
    setPocState(state);
    setPocZip(zip);
    setPocPhone(contact?.phone);
    setPocSecondaryPhone(contact?.secondaryphone);
    setPocEmail(contact?.email);
    setPocCategory(contact?.category);
    setPocType(contact?.type);
    setEdit(contact.id);
    setAddPOCOpen(true);
  };

  const onDelete = (contact) => {
    const [firstname, lastname] = contact.name.split(" ");
    setPocFirstName(firstname);
    setPocLastName(lastname);
    setDel(contact.id);
  };

  const updatePatientZones = async (_locationId, zones) => {
    setPatient((prev) => ({
      ...prev,
      zones,
    }));
  };

  const Avatar = ({
    name,
    image,
    size = "w-10 h-10",
    textSize = "text-base",
    fontWeight = "font-normal",
  }) => {
    return (
      <>
        {image !== null ? (
          <div className="flex items-center gap-2">
            <img
              src={image}
              alt={name}
              className={classNames(
                "object-cover w-10 h-10 rounded-full",
                size
              )}
            />
          </div>
        ) : (
          <p
            className={classNames(
              "flex items-center justify-center m-0 text-white rounded-full bg-primaryblue",
              size,
              textSize,
              fontWeight
            )}
          >
            {name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </p>
        )}
      </>
    );
  };

  const header = {
    "care-team": "Care Team ",
    poc: "Point of Contact ",
    notes: "Notes",
  };

  const headerLength = {
    "care-team": careteam.length,
    poc: poc.length,
    notes: "",
  };


  // Lat-long

  // useEffect(() => {
  //   if (flag) {
  //     setFlag(false);
  //     return;
  //   }
  //   if (patient?.locations?.length > 0) {
  //     // Group addresses by type
  //     const primaryAddresses = patient.locations.filter(addr => addr.type === 'PRIMARY');
  //     const secondaryAddresses = patient.locations.filter(addr => addr.type === 'SECONDARY');

  //     // Set default to first primary address, or first secondary if no primary
  //     const defaultAddress = primaryAddresses.length > 0 ? primaryAddresses[0] : secondaryAddresses[0];

  //     if (defaultAddress) {
  //       console.log(selectedAddressType, ">>llololo")
  //       setSelectedAddressType(defaultAddress.type);
  //       setSelectedAddress(defaultAddress.id.toString());
  //       setCoordinates({
  //         lat: defaultAddress.location.latitude,
  //         lng: defaultAddress.location.longitude
  //       });
  //     }
  //   }
  // }, [patient?.locations]);
  // Lat-long
  useEffect(() => {
    if (patient?.locations?.length > 0) {
      // Check if currently selected address still exists
      const currentSelectedAddress = patient.locations.find(
        addr => addr.id.toString() === selectedAddress
      );

      if (currentSelectedAddress) {
        // Selected address still exists, just update coordinates if needed
        setCoordinates({
          lat: currentSelectedAddress.location.latitude,
          lng: currentSelectedAddress.location.longitude
        });
      } else {
        // Selected address no longer exists, reset to default
        const primaryAddresses = patient.locations.filter(addr => addr.type === 'PRIMARY');
        const secondaryAddresses = patient.locations.filter(addr => addr.type === 'SECONDARY');
        const defaultAddress = primaryAddresses.length > 0 ? primaryAddresses[0] : secondaryAddresses[0];

        if (defaultAddress) {
          setSelectedAddressType(defaultAddress.type);
          setSelectedAddress(defaultAddress.id.toString());
          setCoordinates({
            lat: defaultAddress.location.latitude,
            lng: defaultAddress.location.longitude
          });
        }
      }
    }
  }, [patient?.locations, selectedAddress]); // Add selectedAddress to dependencies


  // Handle address change
  // Get addresses by type
  const getAddressesByType = (type) => {
    return patient?.locations?.filter(addr => addr.type === type) || [];
  };

  // Handle address type change
  const handleAddressTypeChange = (type) => {
    setSelectedAddressType(type);
    const addresses = getAddressesByType(type);
    if (addresses.length > 0) {
      const firstAddress = addresses[0];
      setSelectedAddress(firstAddress.id.toString());
      setCoordinates({
        lat: firstAddress.location.latitude,
        lng: firstAddress.location.longitude
      });
      // fetchCoordinatesFromGoogle(firstAddress.location);
    }
  };

  // Handle individual address selection
  const handleAddressSelect = async (addressId) => {
    setSelectedAddress(addressId);
    const address = patient?.locations.find(addr => addr.id.toString() === addressId);
    if (address) {
      setCoordinates({
        lat: address.location.latitude,
        lng: address.location.longitude
      });
      // await fetchCoordinatesFromGoogle(address.location);
    }
  };

  // Fetch coordinates from Google API
  // const fetchCoordinatesFromGoogle = async (location) => {
  //   setLoading(true);
  //   try {
  //     const addressString = `${location.street}, ${location.city}, ${location.state} ${location.zip}`;
  //     const response = await fetch(
  //       `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(addressString)}&key=AIzaSyD6_mrRmq02L2KzmZ6jzQAYqu4TZIxcHnI`
  //     );
  //     const data = await response.json();

  //     if (data.results && data.results.length > 0) {
  //       const { lat, lng } = data.results[0].geometry.location;
  //       setCoordinates({ lat, lng });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching coordinates:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Handle coordinate save from LatLongDisplay
  const handleCoordinateSave = (updatedLocation) => {
    setPatient((prev) => {
      if (!prev?.locations) return prev;


      // Find the index of the location that matches the updated location
      const updatedLocations = prev.locations.map(patientLocation => {
        // Check if this is the location that was updated
        if (patientLocation.location?.id === updatedLocation?.id) {
          return {
            ...patientLocation,
            location: {
              ...patientLocation.location,
              latitude: updatedLocation.latitude,
              longitude: updatedLocation.longitude,
              coord_generation_type: updatedLocation.coord_generation_type || 'MANUAL'
            }
          };
        }
        return patientLocation;
      });

      return {
        ...prev,
        locations: updatedLocations
      };
    });

    // Also update the local coordinates state to reflect the change immediately
    setCoordinates({
      lat: updatedLocation.latitude,
      lng: updatedLocation.longitude
    });
    setSelectedAddressType(selectedAddressType)

  };

  // Get current selected address data
  const currentAddress = patient?.locations.find(addr => addr.id.toString() === selectedAddress)?.location;
  return (
    <div className="flex flex-row items-start">

      <Loading loading={isLoading} />
      <div className="w-4/12 py-4 pl-16 pr-8">
        <div className="w-full overflow-x-auto overflow-y-auto h-[calc(100vh-128px)] bg-white rounded-lg shadow border-1 border-primarygrayborder">
          <div className="flex flex-row items-center justify-between">
            <button className="p-3 text-primaryblue" onClick={handleBack}>
              Back
            </button>
          </div>
          <div className="flex flex-col items-center justify-end gap-2 p-4 border-b border-b-primarygrayborder">
            <div className="relative">
              <Avatar
                name={patient?.name ?? ""}
                image={null}
                size="w-20 h-20"
                textSize="text-3xl"
                fontWeight="font-semibold"
              />
              <div className="absolute right-0 w-4 h-4 rounded-full bottom-14 bg-primarygreen" />
            </div>
            {patient && (
              <p className="m-0 text-lg font-bold">{patient?.name}</p>
            )}
            <p className="m-0 text-sm text-primarytextgrey">
              EHR ID {patient?.patient_ehr_id} | {patient?.sex}
            </p>
              <p className="m-0 text-sm text-primarytextgrey">
                Primary Department: {patient?.department?.name ?? "NA"}
              </p>
          </div>
          {/* <div className="flex flex-col h-auto gap-4 p-4 border-b border-b-primarygrayborder">
            <p className="m-0 text-lg font-bold">Personal Information</p>
            <div className="flex items-center gap-4">
              {patient && (
                <Tooltip title="Date of Birth">
                  <div className="flex items-center justify-center w-10 h-10 rounded-md bg-blue-50">
                    <MonitorHeartOutlined
                      style={{
                        color: "#828282",
                      }}
                    />
                  </div>
                </Tooltip>
              )}
              <p className="m-0 w-fit">
                {moment(patient?.dob).format("MMMM DD, YYYY")}
              </p>
            </div>
            <div className="flex items-center gap-4">
              {patient && (
                <Tooltip title="Home Address">
                  <div className="flex items-center justify-center w-10 h-10 rounded-md bg-blue-50">
                    <LocationOnOutlined
                      style={{
                        color: "#828282",
                      }}
                    />
                  </div>
                </Tooltip>
              )}
              <div className="flex flex-col">
                <p className="m-0">{patient?.locationAddress}</p>
                <p className="m-0 text-sm text-primarytextgrey">
                  {patient?.locationName == null
                    ? "Private Residence"
                    : patient?.locationName}
                </p>
              </div>
            </div>
          </div> */}
          {user?.permissions?.includes(`${group_name}.view_personal_info`) && <div className="flex flex-col gap-6 p-4 border-b border-b-primarygrayborder">
            <p className="m-0 text-lg font-bold">Personal Information</p>

            {/* Date of Birth Section */}
            <div className="flex flex-col gap-2">
              <p className="m-0 text-sm font-medium text-primarytextgrey">Date of Birth</p>
              <p className="m-0">
                {moment(patient?.dob).format("MMMM DD, YYYY")}
              </p>
            </div>

            {/* Address Section */}
            <div className="flex flex-col gap-3">
              <div className="flex items-center justify-between gap-2">
                <p className="m-0 text-sm font-medium text-primarytextgrey">Address</p>
                <select
                  className="text-sm border rounded px-2 py-1"
                  value={selectedAddressType}
                  onChange={(e) => handleAddressTypeChange(e.target.value)}
                  disabled={!user?.permissions?.includes(`${group_name}.edit_personal_info`)}
                >
                  <option value="PRIMARY">Primary</option>
                  {getAddressesByType('SECONDARY').length > 0 && (
                    <option value="SECONDARY">Secondary</option>
                  )}
                </select>
              </div>
              {getAddressesByType(selectedAddressType).length > 0 && (
                <div className="flex flex-col gap-2">
                  <p className="m-0 text-sm font-medium text-primarytextgrey">Select Address</p>
                  <div className="flex flex-col gap-2 max-h-32 overflow-y-auto">
                    {getAddressesByType(selectedAddressType).map((address) => (
                      <div
                        key={address.id}
                        className={`p-2 border rounded cursor-pointer ${selectedAddress === address.id.toString()
                          ? 'border-blue-500 bg-blue-50'
                          : 'border-gray-200 hover:bg-gray-50'
                          }`}
                        onClick={() => !user?.permissions?.includes(`${group_name}.edit_personal_info`) ? handleAddressSelect(address.id.toString()) : null}
                      >
                        <div className="flex flex-col gap-1">
                          <p className="m-0 font-medium text-sm">{address.location.street}{address?.address2 != null && address?.address2 !== '' ? `, ${address?.address2}` : ''}</p>
                          <p className="m-0 text-xs text-primarytextgrey">
                            {address.location.city}, {address.location.state} {formatZipCode(address.zip ?? address.location.zip)}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Address Display */}
              {/* {currentAddress && (
                <div className="flex flex-col gap-1">
                  <p className="m-0 font-medium">{currentAddress.street}</p>
                  <p className="m-0 text-primarytextgrey">
                    {currentAddress.city}, {currentAddress.state} {currentAddress.zip}
                  </p>
                  <p className="m-0 text-sm text-primarytextgrey">
                    {currentAddress.type === 'PRIVATE_HOME' ? '(Private Residence)' : `(${currentAddress.type})`}
                  </p>
                </div>
              )} */}
              {/* Reusable Coordinates Component */}
              {getAddressesByType(selectedAddressType).length > 0 && <LatLongDisplay
                latitude={coordinates.lat}
                longitude={coordinates.lng}
                patientId={patient?.id}
                onAddressUpdate={handleCoordinateSave}
                loading={loading}
                editable={true}
                address={patient?.locations?.find(i => i?.id == selectedAddress)?.location}
                disabled={!user?.permissions?.includes(`${group_name}.edit_personal_info`)}
              />}
            </div>
          </div>}
          <div className="flex flex-col h-auto gap-4 p-4">
            <p className="m-0 text-lg font-bold">Service Information</p>
            {user?.permissions?.includes(`${group_name}.view_care_team`) && <button
              onClick={() => handleTabChange("care-team")}
              className="flex items-center gap-4 cursor-pointer"
            >
              <div
                className={classNames(
                  "flex items-center justify-center w-10 h-10 rounded-md",
                  tab === "care-team" && "bg-subtleblue"
                )}
              >
                <PeopleSharp
                  style={{
                    color: tab === "care-team" ? "#3062D4" : "#000",
                    fontSize: "20px",
                  }}
                />
              </div>
              <p
                className={classNames(
                  "m-0 font-semibold",
                  tab === "communities" && "text-primaryblue"
                )}
              >
                Care Team ({headerLength["care-team"]})
              </p>
            </button>}
            {user?.permissions?.includes(`${group_name}.view_poc`) && <button
              onClick={() => handleTabChange("poc")}
              className="flex items-center gap-4 cursor-pointer"
            >
              <div
                className={classNames(
                  "flex items-center justify-center w-10 h-10 rounded-md",
                  tab === "poc" && "bg-subtleblue"
                )}
              >
                <PeopleSharp
                  style={{
                    color: tab === "poc" ? "#3062D4" : "#000",
                    fontSize: "20px",
                  }}
                />
              </div>
              <p
                className={classNames(
                  "m-0 font-semibold",
                  tab === "poc" && "text-primaryblue"
                )}
              >
                Point of Contact ({patient?.noOfPOC})
              </p>
            </button>}
            {user?.permissions?.includes(`${group_name}.view_notes`) && <button
              onClick={() => handleTabChange("notes")}
              className="flex items-center gap-4 cursor-pointer"
            >
              <div
                className={classNames(
                  "flex items-center justify-center w-10 h-10 rounded-md",
                  tab === "notes" && "bg-subtleblue"
                )}
              >
                <NoteSharp
                  style={{
                    color: tab === "notes" ? "#3062D4" : "#000",
                    fontSize: "20px",
                  }}
                />
              </div>
              <p
                className={classNames(
                  "m-0 font-semibold",
                  tab === "notes" && "text-primaryblue"
                )}
              >
                Notes ({patient?.notes != null ? 1 : 0})
              </p>
            </button>}
            {user?.permissions?.includes(`${group_name}.view_visit_history`) && <button
              onClick={() => handleTabChange("history")}
              className="flex items-center gap-4 cursor-pointer"
            >
              <div
                className={classNames(
                  "flex items-center justify-center w-10 h-10 rounded-md",
                  tab === "history" && "bg-subtleblue"
                )}
              >
                <Icon
                  style={{
                    color: tab === "history" ? "#3062D4" : "#000",
                    fontSize: "20px",
                  }}
                  name="20-calendar"
                />
              </div>
              <p
                className={classNames(
                  "m-0 font-semibold",
                  tab === "history" && "text-primaryblue"
                )}
              >
                Visit History
              </p>
            </button>}
            {user?.permissions?.includes(`${group_name}.view_insurance`) && <button
              onClick={() => handleTabChange("insurance")}
              className="flex items-center gap-4 cursor-pointer"
            >
              <div
                className={classNames(
                  "flex items-center justify-center w-10 h-10 rounded-md",
                  tab === "insurance" && "bg-subtleblue"
                )}
              >
                <Icon
                  style={{
                    color: tab === "insurance" ? "#3062D4" : "#000",
                    fontSize: "20px",
                  }}
                  name="20-health"
                />
              </div>
              <p
                className={classNames(
                  "m-0 font-semibold",
                  tab === "insurance" && "text-primaryblue"
                )}
              >
                Insurance ({patient?.insurance?.length ?? 0})
              </p>
            </button>}
          </div>
          {/* {process.env.REACT_APP_ENV === "dev" && ( */}
            <div className="flex flex-col h-auto gap-4 p-4 border-t border-t-primarygrayborder">
              <p className="m-0 text-lg font-bold">Additional Information</p>
              {user?.permissions?.includes(`${group_name}.view_provider_gender_preference`) && <AdditionalFields
                title="Provider Gender Preference"
                value={GENDER[patient?.genderPreference] ?? "Any"}
                onEdit={() => setIsEdit("gender")}
                icon={Person}
                editable={user?.permissions?.includes(`${group_name}.edit_provider_gender_preference`)}
              />}
              {/* {user?.permissions?.includes(`${group_name}.view_zones`) && <AdditionalFields
                title="Zones"
                value={
                  patient?.zones?.map((zone) => zone.name).join(", ") || null
                }
                onEdit={() => setZoneEditModalOpen(true)}
                icon={MyLocation}
                editable={user?.permissions?.includes(`${group_name}.edit_zones`)}
              />} */}
              {user?.permissions?.includes(`${group_name}.view_languages`) && (
                <AdditionalFields
                  title="Primary Language"
                  value={
                    patient?.languagePreference == null
                      ? "English"
                      : capitalize(patient.languagePreference)
                  }
                  onEdit={() => setIsEdit("language")}
                  icon={Language}
                  secondaryTitle="Secondary Language"
                  secondaryValue={
                    patient?.secondaryLanguagePreference == null ||
                      patient?.secondaryLanguagePreference === ""
                      ? "None"
                      : patient.secondaryLanguagePreference
                        .split(",")
                        .map((language) => language)
                        .join(", ")
                  }
                  editable={user?.permissions?.includes(`${group_name}.edit_languages`)}
                />
              )}

              {user?.permissions?.includes(`${group_name}.view_referral_source`) && <AdditionalFields
                title="Referral Source"
                value={patient?.referral_source?.name || "NA"}
                onEdit={() => setIsEdit("referral_source")}
                icon={GroupAdd}
                editable={user?.permissions?.includes(`${group_name}.edit_referral_source`)}
              />}
              {user?.permissions?.includes(`${group_name}.view_text_consent`) && <AdditionalFields
                iconName="20-message"
                title="Text Consent"
                value={patient?.text_consent ? "Yes" : "No"}
                onEdit={() => setIsEdit("text_consent")}
                editable={user?.permissions?.includes(`${group_name}.edit_text_consent`)}
              />}
              {user?.permissions?.includes(`${group_name}.view_email_consent`) &&
                <AdditionalFields
                  iconName="20-mail"
                  title="Email Consent"
                  value={patient?.email_consent ? "Yes" : "No"}
                  onEdit={() => setIsEdit("email_consent")}
                  editable={user?.permissions?.includes(`${group_name}.edit_email_consent`)}
                />}
              {user?.permissions?.includes(`${group_name}.view_care_program`) && <AdditionalFields
                iconName="20-health"
                title="Care Program"
                value={
                  patient?.care_programs?.length > 0
                    ? patient?.care_programs?.map((cp) => cp.abbreviation).join(", ") 
                    : null
                }
                onEdit={() => setIsEdit("care_program")}
                editable={user?.permissions?.includes(`${group_name}.edit_care_program`)}
              />}
              {user?.permissions?.includes(`${group_name}.view_risk_level`) && <AdditionalFields
                title="Risk level"
                value={patient?.risk_level}
                onEdit={() => setIsEdit("risk_level")}
                icon={More}
                secondaryTitle="Risk pool indicator"
                secondaryValue={patient?.risk_pool_indicator}
                editable={user?.permissions?.includes(`${group_name}.edit_risk_level`)}
              />}
            </div>
          {/* )} */}
        </div>
      </div>
      <div className="flex flex-col items-start w-8/12 py-4">
        {tab !== "history" && tab !== "insurance" && (
          <div className="flex flex-row items-center justify-between w-full pl-8 pr-16">
            <div className="flex flex-row items-center w-full gap-12">
              {tab !== "notes" && tab !== "history" && (
                <div className="flex flex-row items-center w-full gap-8 max-w-7xl">
                  <Search value={searchFilter} setValue={setSearchFilter} />
                </div>
              )}
              {tab === "zones" && (
                <button
                  onClick={() => {
                    setZoneEditModalOpen(true);
                  }}
                  className="px-4 py-2 shadow-sm rounded-md border-[2px] border-primarygrayborder whitespace-nowrap text-primaryblue"
                >
                  Edit Zones
                </button>
              )}
            </div>
            {tab === "poc" && user?.permissions?.includes(`${group_name}.edit_poc`) && (
              <button
                onClick={() => {
                  setAddPOCOpen(true);
                }}
                className="px-4 py-2 shadow-sm rounded-md border-[2px] border-primarygrayborder whitespace-nowrap text-primaryblue"
              >
                Add New
              </button>
            )}
            {tab === "notes" && user?.permissions?.includes(`${group_name}.edit_notes`) && (
              <button
                onClick={() => {
                  if (isEditNote) {
                    updateNote();
                  }
                  setIsEditNote(!isEditNote);
                }}
                className="px-4 py-2 shadow-sm rounded-md border-[2px] border-primarygrayborder whitespace-nowrap text-primaryblue"
              >
                {isEditNote ? "Save" : "Edit"}
              </button>
            )}
          </div>
        )}
        {tab !== "history" && (
          <div className="w-full pl-8 pr-16">
            <div
              className={classNames(
                "relative w-full mt-8 mb-2 overflow-x-auto overflow-y-auto bg-white rounded-lg shadow  max-h-[calc(100vh-200px)]",
                tab === "notes" && "p-1"
              )}
            >
              {tab === "notes" && (
                <textarea
                  disabled={!isEditNote}
                  rows={5}
                  placeholder="Enter note"
                  className="w-full p-2"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              )}
              {tab === "care-team" ? (
                <table className="relative w-full whitespace-no-wrap bg-white border-collapse table-auto table-striped">
                  <thead>
                    <tr className="h-16 text-base font-bold text-left text-white bg-primaryblue whitespace-nowrap">
                      <th className="px-4 py-3">
                        <p className="m-0">Name</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Speciality</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Role</p>
                      </th>
                      <th className="px-4 py-3">NPI ID</th>
                      <th className="px-4 py-3">Phone No.</th>
                      <th className="px-4 py-3">Email</th>
                      {/* <th className="px-4 py-3">Zone</th> */}
                      <th className="px-4 py-3">
                        <p className="m-0">Status</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {careteam
                      .filter((provider) =>
                        provider.name
                          .toLowerCase()
                          .includes(searchFilter.toLowerCase())
                      )
                      .map((provider, index) => (
                        <tr
                          className={classNames(
                            "text-left text-gray-900 h-24 whitespace-nowrap"
                          )}
                          key={index}
                        >
                          <td className="px-4 py-3 text-left">
                            <div className="flex flex-row items-center gap-4">
                              <button
                                onClick={() => handleProviderClick(provider)}
                                className="flex flex-row items-center gap-4"
                              >
                                <Avatar
                                  // name={provider.name}
                                  name={provider?.name?.replace(/\s*\(.*?\)\s*/g, '') ?? ""}
                                  image={provider.profileImage}
                                />
                                <p className="m-0 font-semibold underline">
                                  {provider.name}
                                </p>
                              </button>
                            </div>
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {provider.speciality}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {provider.role}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {provider.npi_id}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {provider.phone}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {provider.email}
                          </td>
                          {/* <td className="px-4 py-3 text-left text-gray-700">
                            {provider.zones.length > 0
                              ? provider.zones
                                .map((zone) => zone.name)
                                .join(", ")
                              : "NA"}
                          </td> */}
                          <td className="px-4 py-3 text-left text-gray-700">
                            <div
                              className={classNames(
                                provider.status.toUpperCase() === "ACTIVE"
                                  ? "bg-subtlegreen border-[1px] border-primarygreen text-primarygreen"
                                  : "bg-primarylightgrey border-[1px] border-primarygrayborder text-primarytextgrey",
                                "rounded-md text-center flex flex-row gap-1 items-center px-2 w-fit"
                              )}
                            >
                              <div
                                className={classNames(
                                  "w-2 h-2 rounded-full",
                                  provider.status.toUpperCase() === "ACTIVE"
                                    ? "bg-primarygreen"
                                    : "bg-primarytextgrey"
                                )}
                              />
                              {provider.status}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : tab === "poc" ? (
                <table className="relative w-full whitespace-no-wrap bg-white border-collapse table-auto min-h-28 table-striped">
                  <thead>
                    <tr className="h-16 text-base font-bold text-left text-white bg-primaryblue whitespace-nowrap">
                      <th className="px-4 py-3">
                        <p className="m-0">Name</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Category</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Type</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Email</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Home Phone</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Mobile Phone</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Work Phone</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Address</p>
                      </th>
                      <th className="px-4 py-3">
                        <p className="m-0">Status</p>
                      </th>
                      {user?.permissions?.includes(`${group_name}.edit_poc`) && (
                        <>
                          <th className="px-4 py-3">
                            <p className="m-0">Edit</p>
                          </th>
                          <th className="px-4 py-3">
                            <p className="m-0">Delete</p>
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {poc
                      .filter((contact) =>
                        contact.name
                          .toLowerCase()
                          .includes(searchFilter.toLowerCase())
                      )
                      .map((contact, index) => (
                        <tr
                          className={classNames(
                            "text-left text-gray-900 h-24 whitespace-nowrap"
                          )}
                          key={index}
                        >
                          <td className="px-4 py-3 text-left">
                            <div className="flex flex-row items-center gap-4">
                              <button className="flex flex-row items-center gap-4">
                                <Avatar name={contact.name} image={null} />
                                <p className="m-0 font-semibold underline">
                                  {contact.name}
                                </p>
                              </button>
                            </div>
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {contact.category}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {contact.type}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {contact.email}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {contact.phone}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {contact.secondaryphone}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {contact.workphone}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            {contact.address}
                          </td>
                          <td className="px-4 py-3 text-left text-gray-700">
                            <div
                              className={classNames(
                                contact.status.toUpperCase() === "ACTIVE"
                                  ? "bg-subtlegreen border-[1px] border-primarygreen text-primarygreen"
                                  : "bg-primarylightgrey border-[1px] border-primarygrayborder text-primarytextgrey",
                                "rounded-md text-center flex flex-row gap-1 items-center px-2 w-fit"
                              )}
                            >
                              <div
                                className={classNames(
                                  "w-2 h-2 rounded-full",
                                  contact.status.toUpperCase() === "ACTIVE"
                                    ? "bg-primarygreen"
                                    : "bg-primarytextgrey"
                                )}
                              />
                              {contact.status}
                            </div>
                          </td>
                          {user?.permissions?.includes(`${group_name}.edit_poc`) && (
                            <>
                              <td className="px-4 py-3 text-left text-gray-700">
                                <IconComponent
                                  title="Edit Contact"
                                  icon={"Edit_Icon"}
                                  i={contact}
                                  onClick={() => onEdit(contact)}
                                />
                              </td>
                              <td className="px-4 py-3 text-left text-gray-700">
                                <IconComponent
                                  title="Delete Contact"
                                  icon={"Delete_Icon"}
                                  i={contact}
                                  onClick={() => onDelete(contact)}
                                />
                              </td>
                            </>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : tab === "zones" ? (
                <table className="relative w-full whitespace-no-wrap bg-white border-collapse table-auto min-h-28 table-striped">
                  <thead>
                    <tr className="h-16 text-base font-bold text-left text-white bg-primaryblue whitespace-nowrap">
                      <th className="px-4 py-3">
                        <p className="m-0">Name</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {patient?.zones?.map((zone, index) => (
                      <tr key={index}>
                        <td className="px-4 py-3 text-left text-gray-700">
                          {zone.name}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : tab === "insurance" ? (
                <InsuranceDetails patient={patient} editable={user?.permissions?.includes(`${group_name}.edit_insurance`)} />
              ) : null}
            </div>
          </div>
        )}
        {tab === "history" && <VisitHistory patientId={id} groupName={group_name} />}
      </div>
      {/* max-h-[calc(100vh-200px)] */}
      <POCModal
        addPOCOpen={addPOCOpen}
        edit={edit}
        clearInput={clearInput}
        pocFirstName={pocFirstName}
        setAddPOCOpen={setAddPOCOpen}
        setPocFirstName={setPocFirstName}
        pocLastName={pocLastName}
        setPocLastName={setPocLastName}
        pocStreet={pocStreet}
        setPocStreet={setPocStreet}
        pocCity={pocCity}
        setPocCity={setPocCity}
        pocState={pocState}
        setPocState={setPocState}
        pocZip={pocZip}
        setPocZip={setPocZip}
        pocEmail={pocEmail}
        setPocEmail={setPocEmail}
        pocPhone={pocPhone}
        setPocPhone={setPocPhone}
        pocSecondaryPhone={pocSecondaryPhone}
        setPocSecondaryPhone={setPocSecondaryPhone}
        pocCategory={pocCategory}
        setPocCategory={setPocCategory}
        pocType={pocType}
        setPocType={setPocType}
        onUpdatePOC={onUpdatePOC}
        savePOC={savePOC}
      />
      <POCDeleteModal
        del={del}
        clearInput={clearInput}
        pocFirstName={pocFirstName}
        onDeletePOC={onDeletePOC}
      />
      {isEdit && (
        <PatientUpdateModal
          open={isEdit}
          setOpen={setIsEdit}
          data={patient}
          setData={setPatient}
          referralSource={referralSource}
       
        />
      )}
      {patient && (
        <PatientZoneEditModal
          open={zoneEditModalOpen}
          setOpen={setZoneEditModalOpen}
          patient={patient}
          updatePatientZones={updatePatientZones}
        />
      )}
    </div>
  );
};

export default PatientInfo;

const AdditionalFields = ({
  iconName,
  icon: IconMUI,
  title,
  value,
  onEdit,
  secondaryTitle,
  secondaryValue,
  editable,
}) => {
  return (
    <div className="flex  gap-4">
      <Tooltip title={title}>
        <div className="flex items-center justify-center w-12 h-12 rounded-md bg-subtleblue">
          {IconMUI ? (
            <IconMUI
              style={{
                color: "#828282",
                fontSize: "20px",
              }}
            />
          ) : (
            <Icon
              style={{
                color: "#828282",
                fontSize: "20px",
              }}
              name={iconName}
            />
          )}
        </div>
      </Tooltip>
      <div className="flex flex-col w-full">
        <div className="flex flex-row items-center justify-between gap-2">
          <span className="m-0 font-semibold">{title}</span>{" "}
          <button className="text-[#828282] disabled:opacity-50 disabled:cursor-not-allowed" onClick={onEdit} disabled={!editable}>
            <Edit />
          </button>
        </div>
        <p className="m-0">{value == null ? "NA" : value}</p>
        {secondaryTitle && (
          <p className="m-0 text-sm text-primarytextgrey">
            <span className="font-semibold">{secondaryTitle}:</span>{" "}
            {secondaryValue == null ? "NA" : secondaryValue}
          </p>
        )}
      </div>
    </div>
  );
};


